import { render, staticRenderFns } from "./ManageCalibrationPatternerMetricsRanges.vue?vue&type=template&id=bb8bc35a&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./ManageCalibrationPatternerMetricsRanges.vue?vue&type=style&index=0&id=bb8bc35a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8bc35a",
  null
  
)

export default component.exports